function Header(props) {
  return (
    <header>
      <div className="container flex space-between">
        <h1>{props.app}</h1>
        <div className="header-list flex">
          <nav>
            <ul className="flex">
              {props.list.map(link => (
                <li key={link.index}>
                  <a href="link.url">{link.name}</a>
                </li>
              ))}
            </ul>
          </nav>  
        </div>
      </div>
    </header>
  )
}

export default Header;